// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "21ceb21527f656667606" + ".chunk.js";
};